import { FirestoreService } from "../firebase/firestoreService";
import {
  FirestoreCollectionReference,
  FirestoreDocumentReference,
} from "../firebase/references";

export interface CsvConfigData {
  auth_status_mapping?: {
    auth_contains?: string[];
    auth_starts_with?: string[];
    auth_indicators?: string[];
    no_auth_contains?: string[];
    no_auth_starts_with?: string[];
    no_auth_indicators?: string[];
  };
  column_default_values?: {
    auth_status?: "no_auth_required" | "auth_required";
  };
  [key: string]: any;
}

export class NarCsvConfigService {
  static async getCsvConfig(
    payerId: string,
    subcollection: string,
  ): Promise<CsvConfigData> {
    try {
      const documentPath = FirestoreDocumentReference.narCsvConfig(
        payerId,
        subcollection,
      );
      const data =
        await FirestoreService.getDocument<CsvConfigData>(documentPath);
      return data;
    } catch (error) {
      console.error("Error fetching CSV config:", error);
      throw error;
    }
  }

  static async updateCsvConfig(
    payerId: string,
    subcollection: string,
    data: Partial<CsvConfigData>,
  ): Promise<void> {
    try {
      const collectionPath = FirestoreCollectionReference.narCsvConfigVersions(
        payerId,
        subcollection,
      );
      const docId = "latest";
      await FirestoreService.updateDocument(collectionPath, docId, data);
    } catch (error) {
      console.error("Error updating CSV config:", error);
      throw error;
    }
  }
}
